import { render, staticRenderFns } from "./CkeditorComponent.vue?vue&type=template&id=9228c966"
import script from "./CkeditorComponent.vue?vue&type=script&lang=js"
export * from "./CkeditorComponent.vue?vue&type=script&lang=js"
import style0 from "./CkeditorComponent.vue?vue&type=style&index=0&id=9228c966&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports